import React from 'react';

import FormAddress from '../../../../../Forms/Common/FormAddress/FormAddress';
import { QuestionTypeShowProps } from './QuestionShow';

export default function LocationShow({
  errors,
  index,
  geojson,
  form,
  question,
  disabled,
  scope,
  hiddenLabel,
}: QuestionTypeShowProps) {
  const { control, watch, setValue, setError, clearErrors, register } = form;
  const inputNamePrefix = `${scope}answers_attributes[${index}]`; // Need the array brackets to be lodash compatible

  return (
    <FormAddress
      clearErrors={clearErrors}
      control={control}
      errors={errors}
      index={index}
      latName={`${inputNamePrefix}.lat`}
      lngName={`${inputNamePrefix}.lng`}
      name={`${inputNamePrefix}.content`}
      register={register}
      disabled={disabled}
      required={question.required}
      setError={setError}
      setValue={setValue}
      geojson={geojson}
      watch={watch}
      hiddenLabel={hiddenLabel}
    />
  );
}
